import React, { useEffect, useRef, useState } from "react";
import "../App.scss";
import "@fontsource/montserrat/300.css";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";

import LanguagePicker from "../LanguagePicker";
import { Tooltip } from "react-tooltip";
import EditProfileDialog from "./EditProfileDialog";
import CheckIfGoingBackDialog from "./dialogs/CheckIfGoingBackDialog";
import universalstorageHandler, { enumStorageMode } from "../persistence/UniversalstorageHandler";
import Browser from "../browser";
import LanguagePickerWithIcon from "../LanguagePickerWithIcon";
import { itx, noItx } from "../translationItx/itx";

import ServerDataBaseHandler from "../persistence/SeverDataBaseHandler";
import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";

function Avatar(props: { text: string; foregroundColor?: string; backgroundColor?: string }) {
  const {} = props;

  useOnChangeWatcher(state.profilePicture);

  const [url, setUrl] = useState(localStorage.getItem(`profilePicture${state.loggedInUser?.id || ""}`) as string);
  // with color scs vars not possible (can`t find the colours)
  const backgroundColor = props?.backgroundColor ? props?.backgroundColor : "#ffae4b";

  const foregroundColor = props?.foregroundColor ? props?.foregroundColor : "#fff";

  const foregroundColor1 = "#ffa009";

  // const refCanvas = useRef<HTMLCanvasElement>(null);
  const elem = window.document.createElement("canvas");

  var c = elem;

  function createCanvasDrawing(): string {
    if (c && state.loggedInUser) {
      var context = c.getContext("2d");
      c.width = 250;
      c.height = 250;

      let userName = state.loggedInUser.name as string;
      if (!userName) {
        userName = state.loggedInUser.email as string;
      }
      const firstNameLetter = userName.substring(0, 1).toLocaleLowerCase();
      let lastNameLetter = userName
        .substring(userName.lastIndexOf(" ") + 1, userName.lastIndexOf(" ") + 2)
        .toLocaleLowerCase();
      if (userName.lastIndexOf(".") != -1) {
        lastNameLetter = userName.substring(userName.indexOf(".") + 1, userName.indexOf(".") + 2).toLocaleLowerCase();
      }

      const d = 40;
      if (context) {
        // Draw background
        context.fillStyle = backgroundColor;
        context.fillRect(0, 0, c.width, c.height);

        // Draw text
        context.font = "bold 100px Arial";
        context.fillStyle = foregroundColor;
        context.textAlign = "center";
        context.textBaseline = "middle";
        context.fillText(firstNameLetter, c.width / 2 - d, c.height / 2);
        context.font = "bold 130px Arial";
        context.fillStyle = foregroundColor;

        context.fillText(lastNameLetter, c.width / 2 + d, c.height / 2);
      }
    }
    return elem.toDataURL("image/jpeg");
  }

  useEffect(() => {
    if (url === null || url === undefined) {
      // here draw new profile Picture

      const drawingAsString = createCanvasDrawing();
      if (drawingAsString != undefined) {
        setUrl(drawingAsString);
        localStorage.setItem(`profilePicture${state.loggedInUser?.id || ""}`, drawingAsString);
      }
    }
  });

  useEffect(() => {}, [url]);

  const imgRef = useRef<HTMLImageElement>(null);

  function setFallbackImage() {
    if (imgRef.current) {
      imgRef.current.onerror = null;
      const localCallculatedImage = "";
      imgRef.current.src = localCallculatedImage;
    }
  }

  return (
    <div
      className="menu-item-wrapper"
      style={{
        padding: "5px",
        cursor: "pointer",
      }}
      onClick={(event) => {
        if (
          (event.target as HTMLElement).className.startsWith("menu-item-wrapper") ||
          (event.target as HTMLElement).className.startsWith("profP")
        ) {
          state.dialogManager.openDialog(<EditProfileDialog />);
        }
      }}
      data-tooltip-id={"showhide-tooltip"} // no itx
      data-tooltip-content={state.loggedInUser?.name}
      data-tooltip-place="bottom"
    >
      <Tooltip
        id="showhide-tooltip"
        hidden={state.dialogManager.isOpen}
        style={{ maxWidth: "50vw", whiteSpace: "pre-line" }}
      />
      <img className="profP" src={url}></img>

    </div>
  );
}

export default function HeaderBar({ projectSelection = false }: { projectSelection?: boolean }) {
  const [serverIsOnline, setServerIsOnline] = useState(true);

  useEffect(() => {
    ServerDataBaseHandler.serverIsOnline().then((online) => {
      setServerIsOnline(online);
    });
  }, []);

  const username = localStorage.getItem("user");

  var userIntials = "ES"; // no itx
  if (username && username != "") {
    const jUnsername = JSON.parse(username);
    userIntials = jUnsername.email?.substring(0, 2);
  }

  const styleLanguagePicker: any = {
    backgroundColor: "var(--colorTransparent)",
    position: "relative",
    width: "max-content",
    borderColor: "var(--colorTransparent)",
  };

  const [gridMode, setMultiColumnView] = useState(false);

  function checkIfRealyGoBack() {
    function onOk() {
      universalstorageHandler.deleteProject(state.projectMetadata.id);
      state.clearDirty();
      state.navigate("/");
      return true;
    }
    if (state.projectMetadata.name != "") {
      state.dialogManager.openDialog(<CheckIfGoingBackDialog onOk={onOk} />);
    } else {
      onOk();
    }
  }

  const mobile = Browser.isMobile();
  function WhatsAppSupportButton(params: {}) {
    return (
      <div style={{ marginLeft: "15px", marginRight: "5px" }}>
        <Link to={noItx("https://wa.me/1728926470")} style={{ textDecoration: "none" }}>
          <button
            className="button"
            style={{
              backgroundColor: "#25d366",
              color: "white",
              borderRadius: "5px",
              height: "40px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <i className="lab la-whatsapp" style={{ marginRight: "5px", fontSize: "25px" }} />
            <div style={{}}>{itx("headBar.whatsappSupport", "WhatsApp Support")}</div>
          </button>
        </Link>
      </div>
    );
  }
  function SupportHotlineText(params: {}) {
    return (
      <div style={{ color: "white" }}>
        {itx("HeadBar.supporthotline", "Support Hotline:")}
        <br /> 0228 - 28659540
      </div>
    );
  }
  function SupportEmailButton(params: {}) {
    return (
      <button
        className=""
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          border: "1px solid transparent",
          backgroundColor: "transparent",
          color: "white",
        }}
        onClick={() => (window.location.href = "mailto:Info@Estada.de")} // no itx
      >
        <i className="las la-envelope" style={{ alignSelf: "center" }} />
        <div style={{ marginLeft: "5px" }}>Info@Estada.de</div>
      </button>
    );
  }

  function getAboName(): string {
    let res = state.loggedInUser?.abo || "";
    if (res.indexOf("-") != -1) {
      res = res.substring(0, res.indexOf("-"));
    }
    if (res.includes("dummy")) {
      res = "";
    }
    return res;
  }
  return (
    <div className={`headBar${projectSelection ? " headBar--project-selection" : ""}`}
      data-testid={projectSelection ? "project-selection-header" : undefined}>
      <div
        className="logo"
        style={{
          cursor: window.location.href.includes("quickstart") ? "pointer" : "default",
        }}
        onClick={() => {
          if (window.location.href.includes("quickstart")) {
            checkIfRealyGoBack();
          }
        }}
      >
        <img
          className="headerBrandImage"
          src={`${state.hostBaseUrl}images/logo.png`}
          alt=""
        />
        <span className="headerBrandName">{noItx("ESTADA")}</span>
        {!mobile && state.loggedInUser?.abo != "no" && (
          <span
            className="logoText logoTextHome aboEdit"
            onClick={() => {
              state.navigate("/selfservice");
              // window?.open("https://estada.chargebeeportal.com", "_blank")?.focus();
            }}
            data-tooltip-content={itx("handleTagEdit.editSubscription", "Abos verwalten")}
            data-tooltip-id="tv-tooltip"
            data-tooltip-place="bottom"
          >
            {state.loggedInUser?.abo && getAboName().toUpperCase()}
          </span>
        )}
      </div>
      {!window.location.href.includes("quickstart") && (
        <div className="headBarSupportDesktop" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <SupportHotlineText />
          <WhatsAppSupportButton />
          <SupportEmailButton />
        </div>
      )}

      {projectSelection && <div className="headBarMobileSupport" data-testid="project-selection-mobile-support">
        <div className="headBarMobileContacts">
          <a className="headBarMobileContact headBarMobileHotline" href="tel:+4922828659540">
            <Phone aria-hidden="true" />{itx("headBar.hotline", "Hotline")}
          </a>
          <a className="headBarMobileContact headBarMobileWhatsapp" href={noItx("https://wa.me/1728926470")}
            target="_blank" rel="noopener noreferrer">
            <i className="lab la-whatsapp" aria-hidden="true" />{itx("headBar.whatsapp", "WhatsApp")}
          </a>
          <a className="headBarMobileContact" href={noItx("mailto:Info@Estada.de")}>
            <Mail aria-hidden="true" />{itx("headBar.email", "E-Mail")}
          </a>
        </div>
      </div>}

      {universalstorageHandler.storageMode == enumStorageMode.local && (
        <div className="headBarStorageStatus">
          {!serverIsOnline && (
            <div>{itx("loadNewProfilePicture.deviceWorkingOffline", "Dieses Gerät arbeitet temporär OFFLINE")}</div>
          )}
          {serverIsOnline && <div>{state.translate("headBar.localStorageActive", "Local storage is active ...")} </div>}
        </div>
      )}

      <div className="account">
        {/* <i
          className="las la-question"
          onClick={() => {
            window.open("https://estada.de/hilfe", "_blank");
          }}
          data-tooltip-id="tv-tooltip"
          data-tooltip-content={state.translate("menuBar.help", "Hilfe")}
          data-tooltip-place="top"
        ></i> */}
        {/* <select
          style={{
            backgroundColor: "var(--colorTransparent)",
            border: "1px solid var(--colorTransparent)",
            width: "auto",
            appearance: "none",
            boxShadow: "unset",
          }}
          className="select form-control"
          // defaultValue={state.loggedInUser?.email}
          onChange={(ev) => {
            if (ev.target.value == "logout") {
              setSession(null);
              state.navigate("/login");
            }
          }}
        >
          <option>{state.loggedInUser?.email}</option>
          <option value="logout">{state.translate("loginPage.logout", "Logout")}</option>
        </select> */}
        {!Browser.isMobile() && (
          <div
            className="menu-item-wrapper headBarViewToggle"
            style={{
              padding: "2px 5px",
              cursor: "pointer",
              borderRadius: "2px",
            }}
            data-tooltip-id="tv-tooltip"
            data-tooltip-content={
              gridMode
                ? state.translate("menuBar.listMode", "List Mode")
                : state.translate("menuBar.gridMode", "Grid Mode")
            }
            data-tooltip-place="top" // no itx
            onClick={() => {
              let elements = document.getElementsByClassName("projectCardFlexBox");
              if (elements.length > 0) {
                setMultiColumnView(!gridMode);
                for (const element of elements) {
                  (element as HTMLElement).style.flexDirection = gridMode ? "column" : "row";
                  (element as HTMLElement).style.alignItems = gridMode ? "center" : "stretch"; // no itx
                }
                let textarea = document.getElementsByClassName("question");
                if (textarea.length > 0) {
                  (textarea[0] as HTMLTextAreaElement).style.height = gridMode ? "200px" : "75px"; // no itx
                }
              }
            }}
          >
            <i
              className={gridMode ? "las la-stream la-lg" : "las la-columns la-lg"} // no itx
            ></i>
          </div>
        )}

        <div className="headBarLanguageDesktop">
          {!mobile && (
            <LanguagePicker
              className={"menu-item-wrapper"} // no itx
              style={styleLanguagePicker}
            />
          )}
          {mobile && (
            <LanguagePickerWithIcon
              className={"menu-item-wrapper"} // no itx
              style={styleLanguagePicker}
            />
          )}
        </div>
        {projectSelection && <LanguagePickerWithIcon iconOnly className="headBarMobileLanguage" />}
        <Avatar text={userIntials} />
      </div>
    </div>
  );
}
